module.exports = __webpack_public_path__ + "img/acaki20.ab4b810c.jpg";